var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8536 1.35355C11.0488 1.15829 11.0488 0.841709 10.8536 0.646447C10.6583 0.451184 10.3417 0.451184 10.1464 0.646447L10.8536 1.35355ZM0.146447 10.6464C-0.0488155 10.8417 -0.0488155 11.1583 0.146447 11.3536C0.341709 11.5488 0.658291 11.5488 0.853553 11.3536L0.146447 10.6464ZM0.853553 0.646447C0.658291 0.451184 0.341709 0.451184 0.146447 0.646447C-0.0488155 0.841709 -0.0488155 1.15829 0.146447 1.35355L0.853553 0.646447ZM10.1464 11.3536C10.3417 11.5488 10.6583 11.5488 10.8536 11.3536C11.0488 11.1583 11.0488 10.8417 10.8536 10.6464L10.1464 11.3536ZM10.1464 0.646447L0.146447 10.6464L0.853553 11.3536L10.8536 1.35355L10.1464 0.646447ZM0.146447 1.35355L10.1464 11.3536L10.8536 10.6464L0.853553 0.646447L0.146447 1.35355Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.e80f737fdce10483c623ff93b210078e.svg";
export { ForwardRef as ReactComponent };